import React from "react";
import { db } from "../../../firebase-config";
import { getDoc, doc } from "firebase/firestore";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  Grid,
  MenuItem,
} from "@mui/material";
import SuburbsCard from "./SuburbsCard";

function Suburbs() {
  const [loading, setLoading] = React.useState(true);
  const [data, setData] = React.useState();
  const [year, setYear] = React.useState();
  const [years, setYears] = React.useState([]);
  const [quarter, setquarter] = React.useState();
  const [quarters, setquarters] = React.useState([]);

  const handleYearChange = (event) => {
    setYear(event.target.value);
  };

  const handlequarterChange = (event) => {
    setquarter(event.target.value);
  };

  async function getQueryInfo({ id }) {
    const docRef = doc(db, "suburbs-info", id);
    const docSnap = await getDoc(docRef);
    const data = docSnap.data();
    setData(data);
    setYears(data["years"]);
    setYear(data["latest-year"]);
    setquarters(data["quarters"]);
    setquarter(data["latest-quarter"]);
    setLoading(false);
  }

  React.useEffect(() => {
    getQueryInfo({ id: "data" });
  }, []);

  return loading ? (
    <h1>Loading</h1>
  ) : data.length !== 0 ? (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              <InputLabel id="year-select-label">Year</InputLabel>
              <Select
                labelId="year-select-label"
                id="year-select"
                value={year}
                label="Year"
                onChange={handleYearChange}
              >
                {years.map((yr) => {
                  return <MenuItem value={yr}>{yr}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
              <InputLabel id="quarter-select-label">Quarter</InputLabel>
              <Select
                labelId="quarter-select-label"
                id="quarter-select"
                value={quarter}
                label="Quarter"
                onChange={handlequarterChange}
              >
                {quarters.map((rp) => {
                  return <MenuItem value={rp}>{rp}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Box>
        </Grid>
      </Grid>
      <SuburbsCard year={year} quarter={quarter} />
    </Box>
  ) : (
    <h6>No data Available</h6>
  );
}

export default Suburbs;
